import { HandlerBase } from '../../handler/handler-base'
import { RelatedProductService } from '../services/related-product-service'
import 'jquery'
import 'slick-carousel'
import { $applicationMonitoringService } from '../../application-monitoring'
import { analytics } from 'apollo-web'
import CartHelper from '../../../helpers/cart-helper'
import ShoppingCartService from '../../../shared/shopping-cart/services/shopping-cart-service'
import { BrowserCommunicatorService } from '../../../services/browser-communicator-service'
import { appConstants } from '../../../enums/site-enum'
import { ProductDetailService } from '../../../product-detail/services/product-detail-service'
import { ProductAnalyticsHelper } from '../../helper/product-analytics-helper'
import { fromEvent } from "rxjs"
import AddedProductRelatedEvent from "../events/added-product-related-event"
import UpdateProductEvent from "../../shopping-cart/events/update-product-event"
import MoreProductEvent from "../../shopping-cart/events/more-product-event"
import LessProductEvent from "../../shopping-cart/events/less-product-event"
import SetQuantityProductEvent from "../../shopping-cart/events/set-quantity-product-event"
import RemoveProductEvent from "../../shopping-cart/events/remove-product-event"
import EmptyCartEvent from "../../shopping-cart/events/empty-cart-event"

export class RelatedProductHandlers extends HandlerBase {

    constructor() {
        super()

        this._relatedProductService = new RelatedProductService()
        this._shoppingCartService = new ShoppingCartService(this._getJourneyArea())
        this._browserCommunicatorService = new BrowserCommunicatorService()
        this._productDetailService = new ProductDetailService();
        this._productAnalyticsHelper = new ProductAnalyticsHelper();
    }

    /**
     * 
     * @param initOptions {{slickOptions: {JQuerySlickOptions}}}
     * */
    init(initOptions = {}) {
        $(".related-product-card a").on("click", async e => {
            e.preventDefault();
            await this.onRelatedProductClick(e)
            window.location.href = e.currentTarget.getAttribute("href");
        })

        fromEvent(document.querySelectorAll(".related-product-card__add-to-cart"), "click").subscribe(async e => {
            await this.onAddProductToCard(e)
        });

        this.initSlickCarousel(initOptions.slickOptions)
        this.bindAllProductControls();
        this.bindShoppingCartEvents();
    }

    /**
     * Bind ShoppingCart events
     * - Less products
     * - More products
     * - Set quantity products
     * - remove product
     * - empty cart
     */
    bindShoppingCartEvents() {
        MoreProductEvent.$.subscribe((args) => {
            this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
        })

        LessProductEvent.$.subscribe((args) => {
            this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
        })

        SetQuantityProductEvent.$.subscribe((args) => {
            this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse)
        })

        RemoveProductEvent.$.subscribe(args => {
            this.updateProductQuantity(args.productBranchOfficeId, args.shoppingCartResponse);
        })

        EmptyCartEvent.$.subscribe(_ => {
            this.toggleQuantityBtnV2(".btn-group");
        })
    }

    /**
     * init slick carousel
     * @param slickOptions {JQuerySlickOptions}
     * */
    initSlickCarousel(slickOptions = {}) {
        $(".related-product-card__row").slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false,
            autoplay: true,
            prevArrow: '<button class="button button--secondary-reverse related-product-card__button-prev slick-arrow"><i class="fas fa-chevron-left"></i></button>',
            nextArrow: '<button class="button button--secondary-reverse related-product-card__button-next slick-arrow"><i class="fas fa-chevron-right"></i></button>',
            ...slickOptions,
            responsive: [
                {
                    // small
                    breakpoint: 450,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    // medium
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    // large
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        })
    }

    /**
     * 
     * @param event {Event}
     * */
    async onAddProductToCard(event) {
        event.preventDefault();

        const productId = event.currentTarget.getAttribute("data-product-id")
        const element = $(event.currentTarget)
        const cardElement = element.closest('.related-product-card');
        const loadingTarget = `.related-product-card[data-product-id="${productId}"]`

        this._loading(true, loadingTarget)
        try {
            var imgtodrag = element.closest('.related-product-card').find(".related-product-card__image").eq(0);
            CartHelper.sendProductImageToCar(imgtodrag);

            const addResponse = await this._shoppingCartService.addItemAsync(1, productId, false)
            if (!addResponse.ok) {
                await this.handleErrorCartResponseAsync(addResponse)
                return;
            }

            const value = await addResponse.json();
            if (!value.Successful) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: value.UserMessage
                })
                return;
            }

            const shoppingCartItemChangedResponse = value.Value;
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            // load shoppingcart event
            AddedProductRelatedEvent.added({
                productId: productId,
                shoppingCartItemChanged: shoppingCartItemChangedResponse
            })

            this.toggleQuantityBtn(element);
            cardElement.find(".related-product-card__body--quantity_display").html(shoppingCartItemChangedResponse.ProductQuantity);
            this.bindProductControls(cardElement, productId)

        } catch (e) {
            console.error(e)
        } finally {
            this._loading(false, loadingTarget)
        }

        // dispatch "add to cart" analytics event.
        this._productAnalyticsHelper.trackAddToCart(productId)
            .then(_ => { });
    }

    bindAllProductControls() {
        const productCards = document.querySelectorAll('.related-product-card');
        const productsWithQuantity = Array.from(productCards).filter(element => {
            const quantity = parseInt(element.getAttribute('data-quantity'), 10);
            return quantity > 0;
        });

        for (let element of productsWithQuantity) {
            const productId = element.getAttribute("data-product-id");
            this.bindProductControls($(element), productId);
        }
    }

    /**
     * 
     * @param {JQuery<HTMLElement>} parentElement
     * @param {any} productId
     */
    bindProductControls(parentElement, productId) {
        const addElement = parentElement.find(".related-product-card__body--quantity_add")
        addElement.off("click")
        addElement.on("click", { 'productId': productId }, e => this.moreProductDetail(e))

        const removeElement = parentElement.find(".related-product-card__body--quantity_remove")
        removeElement.off("click")
        removeElement.on("click", { 'productId': productId }, e => this.lessProductDetail(e))

        const quantityElement = parentElement.find(".related-product-card__body--quantity_display")
        quantityElement.off()
        quantityElement.on("click", { 'productId': productId }, e => this.switchToInputDetail(e))
    }

    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    switchToInputDetail(event) {
        const element = $(event.currentTarget)
        var $input = $("<input>", {
            val: element.text(),
            type: "number",
            min: 1
        });
        $input.addClass("related-product-card__body--quantity_display-input");
        element.replaceWith($input);
        $input.on("blur", { ...event.data }, this.switchToSpanDetail.bind(this));
        $input.select();
    }

    /**
     * 
     * @param e {JQuery.BlurEvent}
     * */
    async switchToSpanDetail(e) {
        const element = $(e.currentTarget)
        var $span = $("<span>", {
            text: element.val()
        });
        $span.addClass("button button--secondary-reverse related-product-card__body--quantity_display");
        element.replaceWith($span);
        $span.on("click", { ...e.data }, e => this.switchToInputDetail(e));
        await this.addProductDetail($span, e.data.productId);
    }

    /**
     * 
     * @param span {JQuery<HTMLElement>}
     * @param {string} productId 
     * */
    async addProductDetail(span, productId) {

        const loadingTarget = `.related-product-card[data-product-id="${productId}"]`
        const quantity = span[0].innerText;

        this._loading(true, loadingTarget)

        try {
            const addProductResponse = await this._shoppingCartService.addProductQuantityFetch(productId, quantity)
            if (!addProductResponse.ok) {
                this.handleErrorCartResponseAsync(addProductResponse)
                return;
            }

            const shoppingCartItemChangedResponse = (await addProductResponse.json()).Value
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            UpdateProductEvent.update({
                productBranchOfficeId: productId,
                shoppingCartResponse: shoppingCartItemChangedResponse
            })

            this.updateProductQuantity(productId, shoppingCartItemChangedResponse)

        } catch (e) {
            console.error(e)
        } finally {
            this._loading(false, loadingTarget)
        }
    }


    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    async lessProductDetail(event) {
        event.stopPropagation();

        let productId = event.data.productId;
        const loadingTarget = `.related-product-card[data-product-id="${productId}"]`
        this._loading(true, loadingTarget)

        try {
            const decreaseResponse = await this._shoppingCartService.decreaseProductQuantityFetch(productId)
            if (!decreaseResponse.ok) {
                await this.handleErrorCartResponseAsync(decreaseResponse)
                return;
            }

            const shoppingCartItemChangedResponse = (await decreaseResponse.json()).Value
            if (!shoppingCartItemChangedResponse.Successed) {
                await this._browserCommunicatorService.displayErrorAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
                return;
            }
            else if (shoppingCartItemChangedResponse.Message) {
                await this._browserCommunicatorService.displayInfoAlert({
                    description: shoppingCartItemChangedResponse.Message,
                    html: true
                })
            }

            UpdateProductEvent.update({
                productBranchOfficeId: productId,
                shoppingCartResponse: shoppingCartItemChangedResponse
            })

            this.updateProductQuantity(productId, shoppingCartItemChangedResponse)

        } catch (e) {
            console.error(e)
            await this._browserCommunicatorService.displayErrorAlert({ description: e.message })
        } finally {
            this._loading(false, loadingTarget)
        }
    }

    /**
     * 
     * @param event {JQuery.ClickEvent}
     * */
    async moreProductDetail(event) {
        event.stopPropagation();

        let productId = event.data.productId;
        const loadingTarget = `.related-product-card[data-product-id="${productId}"]`
        this._loading(true, loadingTarget)

        try {
            const shoppingCartResponse = await this._shoppingCartService.increaseProductQuantityFetch(productId)

            if (!shoppingCartResponse.ok) {
                return
            }

            const shoppingCartResponseJson = (await shoppingCartResponse.json()).Value

            // for update the cart price and quantity
            UpdateProductEvent.update({
                productBranchOfficeId: productId,
                shoppingCartResponse: shoppingCartResponseJson
            })

            // update quantity for catalog
            this.updateProductQuantity(productId, shoppingCartResponseJson)

        } catch (e) {
            console.error(e)
            await this._browserCommunicatorService.displayErrorAlert({
                description: e.message
            })
        } finally {
            this._loading(false, loadingTarget)
        }
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} shoppingCartItemChangedResponse 
     */
    updateProductQuantity(productId, shoppingCartItemChangedResponse) {
        const cardElement = $(`.related-product-card[data-product-id="${productId}"]`)
        let newQuantity = shoppingCartItemChangedResponse.ProductQuantity;
        if (newQuantity <= 0) {
            this.toggleQuantityBtn(cardElement.find(".btn-group"));
        }

        let productQuantityElement = cardElement.find('.related-product-card__body--quantity_display');
        productQuantityElement.html(newQuantity);
    }

    /**
     * Toggle quantities buttons
     * @param {JQuery<HTMLButtonElement>} button
     */
    toggleQuantityBtn(button) {
        button.hide();
        button.siblings().show();
    }

    /**
     * Toggle quantities buttons, performace version without JQuery.
     * @param {string} querySelector
     * @returns
     */
    toggleQuantityBtnV2(querySelector) {
        const btnElements = document.querySelectorAll(querySelector);

        if (!btnElements && btnElements.length === 0) return;

        for (var btnElement of btnElements) {

            const parentElement = btnElement.parentElement;
            const children = parentElement.children;

            for (let i = 0; i < children.length; i++) {
                if (children[i] === btnElement) {
                    children[i].style.display = 'none';
                } else {
                    children[i].style.display = 'block';
                }
            }
        }
    }

    /**
     * Return product info
     * @param {string} productId
     * @returns {any}
     */
    async _fetchProduct(productId) {
        try {
            const response = await this._productDetailService.getProductDetail(productId);
            if (!response.ok) {
                return;
            }
            return (await response.json()).Value.ProductDetailInformation;
        } catch (e) {
            console.error(e)
            return;
        }
    }

    /**
     * 
     * @param e {JQuery.ClickEvent}
     * */
    async onRelatedProductClick(e) {
        return Promise.resolve();
    }

    /**
    * 
    * @param {Response | XMLHttpRequest} response
    */
    async handleErrorCartResponseAsync(response) {
        if (response.status === 401) {
            await this._browserCommunicatorService.displayErrorAlert({ description: "No esta autorizado para realizar esta acción" })
        }
    }

}